;(function () {
	const stopVideo = (section) => {
		const videos = section.querySelectorAll('video')
		const buttonsPlay = section.querySelectorAll('.js-play-video-img-text')

		if (videos.length > 0) {
			videos.forEach((video) => {
				video.pause()
			})
		}

		if (buttonsPlay.length > 0) {
			buttonsPlay.forEach((btn) => {
				btn.classList.remove('active')
			})
		}
	}

	const playVideo = (section) => {
		const videos = section.querySelectorAll('video')

		if (videos.length > 0) {
			videos.forEach((video) => {
				const button = video.parentElement.querySelector(
					'.js-play-video-img-text'
				)

				if (video.parentElement.classList.contains('autoplay')) {
					video.autoplay = true

					if (button) {
						button.classList.remove('active')
					}
				}

				if (video.autoplay && video.paused) {
					video.play()

					if (button) {
						button.classList.remove('active')
					}
				}
			})
		}
	}

	const controlsVideo = (section) => {
		const buttonsPlay = section.querySelectorAll('.js-play-video-img-text')
		const buttonsSound = section.querySelectorAll('.js-sound-video-img-text')

		buttonsPlay.forEach((button) => {
			button.onclick = () => {
				const video = button.parentElement.querySelector('video')

				if (video) {
					if (video.paused) {
						setTimeout(() => {
							video.play()
						}, 10)
					} else {
						setTimeout(() => {
							video.pause()
						}, 10)
					}

					button.classList.toggle('active')
				}
			}
		})

		buttonsSound.forEach((button) => {
			button.onclick = () => {
				const video = button.parentElement.querySelector('video')

				if (video) {
					if (video.muted) {
						setTimeout(() => {
							video.muted = false
						}, 10)
					} else {
						setTimeout(() => {
							video.muted = true
						}, 10)
					}
					button.classList.toggle('active')
				}
			}
		})
	}

	const initSection = () => {
		const sections = document.querySelectorAll('.image-with-text-section')

		const sectionObserver = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) playVideo(entry.target)
				else stopVideo(entry.target)
			})
		})

		const sectionResizeObserver = new ResizeObserver((entries) => {
			const [entry] = entries
			playVideo(entry.target)
		})

		sections.forEach((section) => {
			sectionObserver.observe(section)
			sectionResizeObserver.observe(section)
			controlsVideo(section)
		})
	}

	initSection()

	document.addEventListener('shopify:section:load', function () {
		initSection()
	})
})()

document.addEventListener('DOMContentLoaded', function() {
  const slideshows = document.querySelectorAll('[data-slideshow-id]');

  slideshows.forEach(slideshow => {
    const slideshowId = slideshow.getAttribute('data-slideshow-id');
    const slidesWrapper = slideshow.querySelector('.image-with-text__slides-wrapper');
    const slides = slideshow.querySelectorAll('.image-with-text__slide');

    let currentIndex = 0;
    const totalSlides = slides.length;

    if (totalSlides <= 1) return; // No need for slideshow if only one slide

    const updateSlideshow = (index) => {
      // Ensure index is within bounds
      if (index < 0) {
        currentIndex = totalSlides - 1;
      } else if (index >= totalSlides) {
        currentIndex = 0;
      } else {
        currentIndex = index;
      }

      // Update slides position
      const offset = -currentIndex * 100;
      slidesWrapper.style.transform = `translateX(${offset}%)`;

      // Update dots - only for this slideshow
      const dotsContainer = slideshow.closest('.image-with-text');
      if (dotsContainer) {
        const dots = dotsContainer.querySelectorAll('[data-dot-index]');
        dots.forEach((dot) => {
          const dotIndex = parseInt(dot.getAttribute('data-dot-index'));
          if (dotIndex === currentIndex) {
            dot.classList.add('swiper-pagination-bullet-active');
          } else {
            dot.classList.remove('swiper-pagination-bullet-active');
          }
        });
      }
    };

    // Find controls for this specific slideshow
    const controlsContainer = slideshow.closest('.image-with-text');
    if (!controlsContainer) return;

    const prevButton = controlsContainer.querySelector('.js-slideshow-prev');
    const nextButton = controlsContainer.querySelector('.js-slideshow-next');
    const dots = controlsContainer.querySelectorAll('[data-dot-index]');

    // Previous button
    if (prevButton) {
      prevButton.addEventListener('click', (e) => {
        e.preventDefault();
        updateSlideshow(currentIndex - 1);
      });
    }

    // Next button
    if (nextButton) {
      nextButton.addEventListener('click', (e) => {
        e.preventDefault();
        updateSlideshow(currentIndex + 1);
      });
    }

    // Dots click
    dots.forEach((dot) => {
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        const dotIndex = parseInt(dot.getAttribute('data-dot-index'));
        updateSlideshow(dotIndex);
      });
    });

    // Keyboard navigation (for this slideshow when it has focus)
    slidesWrapper.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        updateSlideshow(currentIndex - 1);
      } else if (e.key === 'ArrowRight') {
        updateSlideshow(currentIndex + 1);
      }
    });

    // Touch/swipe support
    let touchStartX = 0;
    let touchEndX = 0;

    slidesWrapper.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    });

    slidesWrapper.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    });

    const handleSwipe = () => {
      const swipeThreshold = 50;
      const diff = touchStartX - touchEndX;

      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          // Swiped left, show next slide
          updateSlideshow(currentIndex + 1);
        } else {
          // Swiped right, show previous slide
          updateSlideshow(currentIndex - 1);
        }
      }
    };

    // Initialize first slide
    updateSlideshow(0);
  });
});